import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from 'src/pages/private';
import CustomerInformation from './CustomerInformation';
import OrderItems from './OrderItems';
import Discounts from './Discounts';
import Surcharges from './Surcharges';
import Summary from './Summary';
import OrderStepper from './OrderStepper';
import {
  Container,
  FixedHeader,
  HeaderRow,
  BackButton,
  BackIcon,
  Title,
  Description,
  ContentBox,
} from './CreateOrder.styles';

const CreateOrder: FC = () => {
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);

  const handleBack = () => {
    navigate(-1);
  };

  const handleNext = () => {
    if (activeStep < 4) {
      setActiveStep(activeStep + 1);
    }
  };

  const handleBackStep = () => {
    if (activeStep > 0) {
      setActiveStep(activeStep - 1);
    }
  };

  const handleStepClick = (step: number) => {
    setActiveStep(step);
  };

  return (
    <MainLayout title="Order Management">
      <Container>
        <FixedHeader>
          <HeaderRow>
            <BackButton onClick={handleBack}>
              <BackIcon className="bx bx-chevron-left" />
            </BackButton>
            <Title>Create New Order</Title>
          </HeaderRow>
          <Description>
            {activeStep === 0 &&
              'Capture customer and delivery-related information.'}
            {activeStep === 1 &&
              'Add products, quantities, and pricing for this order.'}
            {activeStep === 2 && 'Optional price adjustments.'}
            {activeStep === 3 && 'Additional costs.'}
            {activeStep === 4 && 'Order Summary & Confirmation.'}
          </Description>
          <OrderStepper activeStep={activeStep} onStepClick={handleStepClick} />
        </FixedHeader>
        <ContentBox>
          {activeStep === 0 && <CustomerInformation onNext={handleNext} />}
          {activeStep === 1 && (
            <OrderItems onNext={handleNext} onBack={handleBackStep} />
          )}
          {activeStep === 2 && (
            <Discounts onNext={handleNext} onBack={handleBackStep} />
          )}
          {activeStep === 3 && (
            <Surcharges onNext={handleNext} onBack={handleBackStep} />
          )}
          {activeStep === 4 && <Summary onBack={handleBackStep} />}
        </ContentBox>
      </Container>
    </MainLayout>
  );
};

export default CreateOrder;
